import { Paragraph, TextRun, Table, TableRow, TableCell, WidthType, BorderStyle } from 'docx'

const CELL_BORDER = { style: BorderStyle.SINGLE, size: 4, color: 'D1D5DB' }

const cell = (text, isHeader) =>
    new TableCell({
        shading: isHeader ? { fill: 'F2F2F2' } : undefined,
        margins: { top: 60, bottom: 60, left: 100, right: 100 },
        borders: { top: CELL_BORDER, bottom: CELL_BORDER, left: CELL_BORDER, right: CELL_BORDER },
        children: [new Paragraph({ children: [new TextRun({ text, bold: !!isHeader, size: 18 })] })],
    })

/**
 * Build a real Word table from a parsed markdown table block.
 *
 * Exports used to join each row's cells into a single line of text, which made generated frequency
 * tables unreadable in the downloaded document.
 *
 * @param {{head: string[], rows: string[][]}} block
 */
export function buildDocxTable(block) {
    return new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [
            new TableRow({
                tableHeader: true,
                children: block.head.map((text) => cell(text, true)),
            }),
            ...block.rows.map(
                (row) => new TableRow({ children: row.map((text) => cell(text, false)) })
            ),
        ],
    })
}
